import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_ctx.arr.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["row q-pa-sm", _ctx.$q.dark.isActive ? "bg-grey-10" : "bg-grey-2"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-caption", _ctx.$q.dark.isActive ? "white" : "text-grey-8"])
        }, [
          _createTextVNode(_toDisplayString(_ctx.label), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["q-gutter-sm", { "truncate-chip-labels": _ctx.truncate }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr, (item, index) => {
              return (_openBlock(), _createBlock(_component_q_chip, {
                class: "q-pa-xs",
                key: index,
                square: "",
                removable: "",
                label: item,
                onRemove: ($event: any) => (_ctx.fn(_ctx.arr, index)),
                color: _ctx.$q.dark.isActive ? "blue-grey-6" : "blue-2",
                "text-color": _ctx.$q.dark.isActive ? "white" : "blue-9"
              }, null, 8, ["label", "onRemove", "color", "text-color"]))
            }), 128))
          ], 2)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}